
import './App.css'
import Tours from './Tours'

function App() {
  

  return (
    <>
      <Tours/>
    </>
  )
}

export default App
